export const CategorySection = ({ title, className = "" }) => {
  return (
    <div
      className={`w-[90%] mb-5 mt-0 lg:mt-14 px-4 flex justify-center cursor-default ${className}`}
    >
      <div className="mt-[2rem] lg:mt-4 flex items-center w-fit">
        <div className="h-px w-10 w-16 md:w-60 bg-[#7C4836] opacity-50" />
        <h2 className="mx-2 md:text-xl text-s font-roboto text-[#7C4836] leading-[1.3rem] uppercase tracking-wider text-center whitespace-wrap md:whitespace-nowrap">
          {title}
        </h2>
        <div className="h-px w-10 w-16 md:w-60 bg-[#7C4836] opacity-50" />
      </div>
    </div>
  );
};
